import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import PauseIcon from '@mui/icons-material/Pause';
import StopIcon from '@mui/icons-material/Stop';
import LockIcon from '@mui/icons-material/Lock';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const skipProp =
  (...props: string[]) =>
  (prop: PropertyKey) =>
    !props.includes(prop as string);

export const InterruptSectionContainer = styled(Box)({
  marginTop: 24,
  marginBottom: 8,
});

export const InterruptMenuPauseIcon = styled(PauseIcon)({
  fontSize: 16,
  color: 'var(--am-text-secondary)',
  flexShrink: 0,
});

export const InterruptMenuStopIcon = styled(StopIcon)({
  fontSize: 16,
  color: 'var(--am-text-secondary)',
  flexShrink: 0,
});

export const InterruptMenuLockIcon = styled(LockIcon)({
  fontSize: 16,
  color: 'var(--am-text-secondary)',
  flexShrink: 0,
});

export const BridgeGapsBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  marginTop: 12,
  padding: 16,
  borderRadius: 8,
  border: '1px solid var(--am-border)',
  backgroundColor: 'var(--am-surface)',
});

export const BridgeGapsTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: 1.3,
  color: 'var(--am-text-primary)',
}) as typeof Typography;

export const BridgeGapsDescription = styled(Typography)({
  fontSize: '13px',
  color: 'var(--am-text-secondary)',
  lineHeight: 1.3,
}) as typeof Typography;

export const InterruptDropdown = styled(Box, {
  shouldForwardProp: skipProp('$open'),
})<{ $open: boolean }>(({ $open }) => ({
  border: $open
    ? '1.5px solid var(--am-accent-text)'
    : '1.5px solid var(--am-border)',
  borderRadius: 8,
  overflow: 'hidden',
  background: 'var(--am-header-bg)',
  transition: 'border-color 0.12s',
}));

export const InterruptDropdownHeader = styled(Box, {
  shouldForwardProp: skipProp('$open'),
})<{ $open: boolean }>(({ $open }) => ({
  padding: '10px 14px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  transition: 'background 0.12s',
  background: $open ? 'var(--am-surface-2)' : 'var(--am-surface)',
  borderBottom: $open ? '1px solid var(--am-border)' : 'none',
  '&:hover': {
    backgroundColor: 'var(--am-surface-2)',
  },
}));

export const InterruptDropdownItem = styled(Box, {
  shouldForwardProp: skipProp('$isSelected', '$isLast'),
})<{ $isSelected: boolean; $isLast: boolean }>(({ $isSelected, $isLast }) => ({
  padding: '10px 14px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  transition: 'background 0.12s',
  backgroundColor: $isSelected ? 'var(--am-surface-2)' : 'transparent',
  borderBottom: $isLast ? 'none' : '1px solid var(--am-border)',
  '&:hover': {
    backgroundColor: 'var(--am-surface-2)',
  },
}));

export const InterruptRadioOuter = styled(Box, {
  shouldForwardProp: skipProp('$isSelected'),
})<{ $isSelected: boolean }>(({ $isSelected }) => ({
  width: 18,
  height: 18,
  borderRadius: '50%',
  border: '2px solid',
  borderColor: $isSelected ? 'var(--am-accent-text)' : 'var(--am-border-mid)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}));

export const InterruptRadioInner = styled(Box)({
  width: 10,
  height: 10,
  borderRadius: '50%',
  backgroundColor: 'var(--am-accent-text)',
});

export const InterruptExpandIcon = styled(ExpandMoreIcon, {
  shouldForwardProp: skipProp('$open'),
})<{ $open: boolean }>(({ $open }) => ({
  color: 'var(--am-text-disabled)',
  fontSize: 18,
  flexShrink: 0,
  transform: $open ? 'rotate(180deg)' : 'none',
  transition: 'transform 0.15s',
}));
